import { createFileRoute } from "@tanstack/react-router";

import { requireSuperAdmin } from "@/features/auth/permissions/requireSuperAdmin";
import { CreditsPage } from "@/features/billing";
import { requireSubscriptionManagement } from "@/lib/subscription-management";

export const Route = createFileRoute("/_auth/_app-shell/billing/credits")({
  beforeLoad: async ({ context }) => {
    requireSuperAdmin(context);
    await requireSubscriptionManagement();
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <CreditsPage />;
}
